<template>
  <div class="box">
    <img class="bg" src="@/assets/image/home/qiyeshiming/bg.webp" alt="" srcset="" />
    <div class="content">
      <div class="top">
        <div class="icon">
          <img src="@/assets/image/home/qiyeshiming/icon.webp" alt="" srcset="" />
        </div>
      </div>
      <div class="title">
        <div class="title_t">{{ chaxunData.name }}</div>
        <div class="title_time">创建时间：{{ chaxunData.createdAt|timeFormat("yyyy-mm-dd hh:MM:ss") }}</div>
      </div>
      <div class="main">
        <div class="item">
          <div class="item_t">工商执照注册号/统一社会信用代码</div>
          <div class="item_b">{{ chaxunData.idNumber }}</div>
        </div>
        <div class="solid"></div>
        <div class="item">
          <div class="item_t">企业管理员</div>
          <div class="item_b">{{ chaxunData.representativeName }}</div>
        </div>
        <div class="solid"></div>
        <div class="item">
          <div class="item_t">联系电话</div>
          <div class="item_b">{{ chaxunData.representativePhone }}</div>
        </div>
      </div>
      <div class="text1">
        搜索的<span>「{{ chaxunData.name }}」</span>已存在
      </div>
      <div class="btns">
        <el-button class="button" plain type="primary" @click="onback">上一步</el-button>
        <el-button class="button" type="primary" @click="onnext">申请加入</el-button>
      </div>
      <div class="text2">
        <span class="span1"
          >可联系企业管理员（{{ chaxunData.representativeName }}）邀请您加入</span
        >
        ，或点击
        <span class="span2">申请加入</span> 按钮发送申请，管理员同意后即可认证成功
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "./mixins";
export default {
  mixins: [mixins],
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    onback() {
      this.setStep("chaxun");
    },
    onnext() {
      this.setStep("jiaru2");
    },
  },
};
</script>

<style scoped lang="scss">
@use './style.scss' as *;
</style>
